import React from 'react';
import { REGISTRATION_TABS_MAPPING } from '../../../../common/commonConstant';
import './RegistrationTabs.scss';

const RegistrationTabs = ({ onTabClick = () => { }, activeTab }) => {
  return <nav className="registration-member-type-nav">
    <div className="nav nav-tabs" id="nav-tab" role="tablist">
      {Object.values(REGISTRATION_TABS_MAPPING).map((item) => (
        <button key={item.name} onClick={() => onTabClick(item.name)} className={`nav-link${activeTab === item.name ? ' active' : ''}`} id={`nav-${item.name}-tab`} data-bs-toggle="tab"
          data-bs-target={`#nav-${item.name}`} type="button" role="tab" aria-controls={`nav-${item.name}`}
          aria-selected={activeTab === item.name}>
          <span>{item.label}</span>
        </button>))
      }
    </div>
  </nav>
}

export default RegistrationTabs;